import React from 'react';
import PropTypes from 'prop-types';
import css from './RatingStars.module.css';

/**
 * RatingStars component displays a star rating visualization
 * @param {number} rating - The rating value (0-5)
 * @param {string} className - Optional CSS class name
 */
const RatingStars = ({ rating, className }) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
        <div className={`${css.stars} ${className || ''}`}>
            {Array.from({ length: fullStars }).map((_, i) => (
                <span key={`full-${i}`} className={css.starFilled}>
                    ★
                </span>
            ))}
            {hasHalfStar && (
                <span className={css.starHalf}>
                    ★
                </span>
            )}
            {Array.from({ length: emptyStars }).map((_, i) => (
                <span key={`empty-${i}`} className={css.starEmpty}>
                    ★
                </span>
            ))}
        </div>
    );
};

RatingStars.propTypes = {
    rating: PropTypes.number.isRequired,
    className: PropTypes.string,
};

export default RatingStars;

